import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// import "core-js";

import React from "react";
import ReactDOM from "react-dom";
import "./assets/index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// import redux
import createStore from "./store/store";
import { Provider } from "react-redux";

export const store = createStore();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
